/**
 * Date and time of an instant, rendered in an explicit timezone.
 *
 * Campaign windows carry a meaningful time of day, so showing the date alone
 * hides half the value: a campaign closing at 23:59 and one closing at 00:00
 * look identical while behaving a day apart. The zone is explicit because the
 * user's profile timezone is the one that matters, not the browser's.
 */
export function formatDateTimeInZone(value: string | Date, timeZone: string): string {
  const date = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(date.getTime())) return '-'
  return new Intl.DateTimeFormat(undefined, {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).format(date)
}

/** Date only, in an explicit timezone - for a window said in days (a campaign period). */
export function formatDateInZone(value: string | Date, timeZone: string): string {
  const date = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(date.getTime())) return '-'
  return new Intl.DateTimeFormat(undefined, {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date)
}
